import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8" data-testid="page-header">
      <div>
        {eyebrow && <div className="label-eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-[var(--text-secondary)] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap" data-testid="page-actions">{actions}</div>}
    </div>
  );
}
